import Icon from "@mui/material/Icon";
import SignIn from "layouts/authentication/sign-in";
import Customers from "layouts/customers/index.js";
import Programs from "layouts/programs/index.js";
import Recipes from "layouts/recipes/index.js";
import WorkOuts from "layouts/workouts/index.js";
import CommunityGuidelines from "layouts/communitysection/index.js";
import UserReports from "layouts/userreports/index.js";
import UserPosts from "layouts/userpost/index.js";
import UserPostsByUser from "layouts/userpost/UserPostsByUser";
import Broadcasting from "layouts/brodcastsection";
import MoveNow from "layouts/movenow/index.js";
import DaySchedule from "layouts/dayschedule/index.js";
import RepsAndSets from "layouts/repsandsets/index.js";
import Dashboard from "layouts/dashboard";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />
  },
  {
    type: "collapse",
    name: "Manage Users",
    key: "users",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/users",
    component: <Customers />
  },
  {
    type: "collapse",
    name: "Manage Programs",
    key: "programs",
    icon: <Icon fontSize="small">fitbit</Icon>,
    route: "/programs",
    component: <Programs />
  },
  {
    type: "collapse",
    name: "Manage Recipes",
    key: "recipes",
    icon: <Icon fontSize="small">food_bank</Icon>,
    route: "/recipes",
    component: <Recipes />
  },
  {
    type: "collapse",
    name: "Manage Exercises",
    key: "exercises",
    icon: <Icon fontSize="small">fitness_center</Icon>,
    route: "/exercises",
    component: <WorkOuts />
  },
  {
    type: "collapse",
    name: "Add Daily Schedule",
    key: "dayschedule",
    icon: <Icon fontSize="small">edit_calendar</Icon>,
    route: "/dayschedule",
    component: <DaySchedule />
  },
  {
    type: "collapse",
    name: "Manage Reps and Sets",
    key: "repsandsets",
    icon: <Icon fontSize="small">restart_alt_rounded</Icon>,
    route: "/repsandsets",
    component: <RepsAndSets />
  },
  {
    type: "collapse",
    name: "Manage Post Reports",
    key: "community",
    icon: <Icon fontSize="small">people</Icon>,
    route: "/community",
    component: <CommunityGuidelines />
  },
  {
    type: "collapse",
    name: "Manage User Reports",
    key: "user-reports",
    icon: <Icon fontSize="small">report_problem</Icon>,
    route: "/user-reports",
    component: <UserReports />
  },
  {
    type: "collapse",
    name: "User Posts",
    key: "user-posts",
    icon: <Icon fontSize="small">dynamic_feed</Icon>,
    route: "/user-posts",
    component: <UserPosts />
  },
  {
    name: "User Posts By User",
    key: "user-posts-user",
    route: "/user-posts/detail",
    component: <UserPostsByUser />
  },
  {
    type: "collapse",
    name: "Move Now",
    key: "movenow",
    icon: <Icon fontSize="small">video_label</Icon>,
    route: "/movenow",
    component: <MoveNow />
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/sign-in",
    component: <SignIn />
  },
  {
    type: "collapse",
    name: "Broadcasting",
    key: "broadcasting",
    icon: <Icon fontSize="small">broadcast_on_home</Icon>,
    route: "/broadcasting",
    component: <Broadcasting />
  }
];

export default routes;
